import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  AUTH_VERIFY_TWO_FACTOR_BEGIN,
  AUTH_VERIFY_TWO_FACTOR_SUCCESS,
  AUTH_VERIFY_TWO_FACTOR_FAILURE,
  AUTH_VERIFY_TWO_FACTOR_DISMISS_ERROR,
} from './constants';
import ApiService from '../../common/services/ApiService';

export function verifyTwoFactor(args) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: AUTH_VERIFY_TWO_FACTOR_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      ApiService.verifyTwoFactor(args).then(
        (res) => {
          dispatch({
            type: AUTH_VERIFY_TWO_FACTOR_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: AUTH_VERIFY_TWO_FACTOR_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function resendTwoFactor() {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: AUTH_VERIFY_TWO_FACTOR_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      ApiService.resendTwoFactor().then(
          (res) => {
            dispatch({
              type: AUTH_VERIFY_TWO_FACTOR_SUCCESS,
              data: res,
            });
            resolve(res);
          },
          // Use rejectHandler as the second argument so that render errors won't be caught.
          (err) => {
            dispatch({
              type: AUTH_VERIFY_TWO_FACTOR_FAILURE,
              data: { error: err },
            });
            reject(err);
          },
      );
    });

    return promise;
  };
}

export function dismissVerifyTwoFactorError() {
  return {
    type: AUTH_VERIFY_TWO_FACTOR_DISMISS_ERROR,
  };
}

export function useVerifyTwoFactor() {
  const dispatch = useDispatch();

  const { verifyTwoFactorPending, verifyTwoFactorError, verifyTwoFactorSuccess } = useSelector(
    state => ({
      verifyTwoFactorPending: state.auth.verifyTwoFactorPending,
      verifyTwoFactorError: state.auth.verifyTwoFactorError,
      verifyTwoFactorSuccess: state.auth.verifyTwoFactorSuccess,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(verifyTwoFactor(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissVerifyTwoFactorError());
  }, [dispatch]);

  const boundResendTwoFactor = useCallback(() => {
    return dispatch(resendTwoFactor());
  }, [dispatch]);

  return {
    verifyTwoFactor: boundAction,
    verifyTwoFactorPending,
    verifyTwoFactorError,
    verifyTwoFactorSuccess,
    dismissVerifyTwoFactorError: boundDismissError,
    resendTwoFactor: boundResendTwoFactor,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case AUTH_VERIFY_TWO_FACTOR_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        verifyTwoFactorPending: true,
        verifyTwoFactorError: null,
      };

    case AUTH_VERIFY_TWO_FACTOR_SUCCESS:
      // The request is success
      return {
        ...state,
        verifyTwoFactorPending: false,
        verifyTwoFactorError: null,
        verifyTwoFactorSuccess: action.data,
      };

    case AUTH_VERIFY_TWO_FACTOR_FAILURE:
      // The request is failed
      return {
        ...state,
        verifyTwoFactorPending: false,
        verifyTwoFactorError: action.data.error,
      };

    case AUTH_VERIFY_TWO_FACTOR_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        verifyTwoFactorError: null,
      };

    default:
      return state;
  }
}
